import React, { useRef, useEffect, useState } from 'react';
import styles from './BottomNavBar.module.scss';
import { FaChevronLeft, FaChevronRight } from 'react-icons/fa';

const sections = [
  { id: 'hero', label: 'Hero' },
  { id: 'timeline', label: 'Timeline' },
  { id: 'problem', label: 'Problem' },
  { id: 'revenue', label: 'Revenue Projections' },
  { id: 'solution', label: 'Solution' },
  { id: 'howitworks', label: 'How it works' },
  { id: 'keydifferentiators', label: 'Key Differentiators' },
  { id: 'realestate', label: 'Real Estate' },
  { id: 'growth', label: 'Growth' },
  { id: 'team', label: 'Team' },
  { id: 'tokenomics', label: 'Tokenomics' },
  { id: 'express-interest', label: 'Express Your Interest' },
];

function scrollToSection(id) {
  // Special handling for hero section to ensure it scrolls to the very top
  if (id === 'hero') {
    // Force immediate scroll to top
    window.scrollTo(0, 0);
    return;
  }

  const el = document.getElementById(id);
  if (el) {
    el.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }
}

const BottomNavBar = () => {
  const [current, setCurrent] = useState(0);
  const sectionRefs = useRef([]);

  useEffect(() => {
    const handleScroll = () => {
      // If near bottom, always select last section
      if ((window.innerHeight + window.scrollY) >= (document.body.offsetHeight - 2)) {
        setCurrent(sections.length - 1);
        return;
      }
      let found = 0;
      for (let i = 0; i < sections.length; i++) {
        const el = document.getElementById(sections[i].id);
        if (el) {
          const rect = el.getBoundingClientRect();
          if (rect.top <= 80) found = i;
        }
      }
      setCurrent(found);
    };
    window.addEventListener('scroll', handleScroll);
    handleScroll();
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const goTo = idx => {
    // Special case for hero section
    if (idx === 0) {
      setCurrent(0);
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
    } else {
      scrollToSection(sections[idx].id);
    }
  };

  // Separate handlers for previous and next buttons
  const handlePrev = () => {
    if (current <= 0) return; // Do nothing if already at first section
    
    const prevIndex = current - 1;
    
    // Force direct scroll to top when going to hero section
    if (prevIndex === 0) {
      // First navigate to avoid race conditions
      setCurrent(prevIndex);
      // Then immediately force scroll to top
      setTimeout(() => {
        window.scrollTo(0, 0);
      }, 10);
    } else {
      // Normal navigation for other sections
      goTo(prevIndex);
    }
  };
  
  const handleNext = () => {
    if (current >= sections.length - 1) return; // Do nothing if already at last section
    goTo(current + 1);
  };

  return (
    <nav className={styles.bottomNav}>
      <div className={styles.progressBar}>
        {sections.map((s, idx) => (
          <div
            key={s.id}
            className={styles.progressSegment + ' ' + (current === idx ? styles.active : '')}
            style={{ width: `${100 / sections.length}%` }}
            onClick={() => goTo(idx)}
          />
        ))}
      </div>
      <button
        className={styles.navBtn}
        onClick={handlePrev}
        disabled={current === 0}
        aria-label="Previous section"
      >
        <FaChevronLeft />
      </button>
  
        <span className={styles.pagination}>{current + 1} / {sections.length}</span>
        <div style={{width: '200px', flexDirection: 'column', alignItems: 'center', textAlign: 'center'}} className={styles.sectionLabel}>{sections[current].label}</div>
    
      <button
        className={styles.navBtn}
        onClick={handleNext}
        disabled={current === sections.length - 1}
        aria-label="Next section"
      >
        <FaChevronRight />
      </button>
    </nav>
  );
};

export default BottomNavBar;
